/**
 * GuestbookSection -- 방명록 섹션 편집 + 소유자 관리
 */

import { useInvitationStore } from '../../../stores/invitationStore.js'
import { Toggle } from '../../ui/index.js'
import { GuestbookOwnerList } from '../../templates/blocks/guestbook/GuestbookOwnerList.js'
import styles from './SectionForm.module.css'

export function GuestbookSection() {
  const invitation = useInvitationStore((s) => s.invitation)
  const updateNested = useInvitationStore((s) => s.updateNested)
  if (!invitation) return null

  const requirePassword = invitation.settings?.requirePassword ?? false
  const isPublished = invitation.status === 'PUBLISHED'

  return (
    <div className={styles.form}>
      <Toggle
        label="비밀번호 보호"
        checked={requirePassword}
        onChange={(v) => updateNested('settings.requirePassword', v)}
      />
      <p className={styles.hint}>
        방명록은 발행 후 방문자가 작성할 수 있습니다
      </p>

      {isPublished ? (
        <GuestbookOwnerList invitationId={invitation.id} />
      ) : (
        <p className={styles.hint}>
          발행 후 방명록을 관리할 수 있습니다
        </p>
      )}
    </div>
  )
}
